var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"context-menu-item cpt-menu-text-button",class:[
    _vm.data.type,
    {
      'selected': _vm.data.selected,
      'disable': _vm.data.disable,
      'height50': _vm.data.height50,
      'gradient': _vm.data.gradient
    }
  ],style:({ color: _vm.data.color ? _vm.data.color : '' }),on:{"click":function($event){$event.preventDefault();return _vm.clickHandler.apply(null, arguments)}}},[(_vm.data.image)?_c('div',{staticClass:"icon"},[_c('ChatImg',{attrs:{"src":_vm.data.image,"webp_quality":30,"thumbnail":"48x"}})],1):_vm._e(),(_vm.data.icon)?_c('div',{staticClass:"icon"},[_c('span',{class:['iconfont', _vm.data.icon],style:({'background-image': _vm.data.gradient || '' })})]):_vm._e(),_c('p',{staticClass:"label",style:({'background-image': _vm.data.gradient || '' }),domProps:{"innerHTML":_vm._s(_vm.purifyHTML(_vm.data.label))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }